import React, { Component } from 'react';

import { connect } from 'react-redux';
import { firebaseConnect, helpers } from 'react-redux-firebase';

import Input from 'components/Input';
import Button from 'components/Button';

import RemoveIcon from 'assets/icons/minus-circle';

class StudentPanelListItem extends Component {

	constructor(props) {
		super(props);
		this.state = {
			student : this.props.student
		};
	}

	updateStudentName (event) {
		let name = event.target.value;
		let student = this.state.student;
		if (name.length >= 0) {
			this.props.firebase.set(`/classrooms/${this.props.classroom.id}/students/${this.props.student.id}/name`, name);
			student.name = name;
			this.setState({student : student});
		}
	}

	render () {
		let student = this.state.student;
		return (
			<div key={this.props.index} className="list-row">
				<div className="list-cell">
					<Input
						name="studentName"
						value={student.name}
						onChange={this.updateStudentName.bind(this)}
					/>
				</div>
				<div className="list-cell">{student.lesson}</div>
				<div className="list-cell">{student.activity}</div>
				<div className="list-cell no-grow align-right">
					<Button
						tooltipText="Remove"
						tooltipPosition="left"
						icon={RemoveIcon}
						buttonClass="circle transparent tiny hover-red"
						onClick={this.props.deleteStudent.bind(this, student)}
					/>
				</div>
			</div>
		);
	}
}

const fbWrappedComponent = firebaseConnect()(StudentPanelListItem);
export default fbWrappedComponent;



// WEBPACK FOOTER //
// ./js/components/StudentPanelList/StudentPanelListItem.js